import { takeEvery, put, call } from 'redux-saga/effects'
import { normalize } from 'normalizr'
import { ADD_EXM } from 'actions/truck'
import { GET_VEHICLE_CTP } from 'actions/ctp'
import { ctp } from 'services'
import { moduleArraySchema } from 'schemas/ecus'

export default function* watchAddExmSuccess() {
  yield takeEvery(ADD_EXM, addExmSideEffects)
}

function* addExmSideEffects({ serialNumber }) {
  try {
    const response = yield call(ctp.getVehicleCtp, { serialNumber })
    const data = response.data !== undefined ? response.data : response
    const normalized = normalize(data, moduleArraySchema)
    yield put({ type: GET_VEHICLE_CTP, serialNumber, data: normalized })
  } catch (e) {
    // CTP refresh failed — tabs will update on next navigation
  }
}
